export default __webpack_public_path__ + "static/media/topmovie.4946b60b.svg";